/**
 * KPI header/card display: fixed 2 decimal places (e.g. `37.30%`, `12.50`, `3.00` days).
 * Leaves em dash and other non-numeric display strings unchanged.
 */
export function formatKpiTwoDecimalDisplay(value: string | number | null | undefined): string {
  if (value == null) return '—';
  const s0 = String(value).trim();
  if (s0 === '—' || s0 === '-' || s0 === '') return s0 === '' ? '—' : s0;
  const hasPct = s0.includes('%');
  const normalized = s0.replace(/%/g, '').replace(/,/g, '').trim();
  const n = parseFloat(normalized);
  if (!Number.isFinite(n)) return s0;
  return hasPct ? `${n.toFixed(2)}%` : n.toFixed(2);
}

/** Rate string without `%` → `nn.nn%` */
export function formatKpiRatePercentFromNumberString(rateStr: string): string {
  return formatKpiTwoDecimalDisplay(`${String(rateStr).replace(/%/g, '').trim()}%`);
}
